export const INFO_TEXT =
  'В случае отсутствия в конструкторе модулей, отвечающим Вашим требованиям, Вы можете сформировать заявку на новую программу, указав параметры';

export const DESC_TEXT =
  'Если Вас интересует обучение по компетенции или профессии, которой нет в нашем справочнике, опишите требования к интересующей вас компетенции или профессии';

export const PARAM_BUTTON_TEXT = 'Выбрать параметры программы';
export const CLOSE_BUTTON_TEXT = 'Отменить выбор по параметрам';
export const ERROR_TEXT = 'Только целое число больше нуля';



// WEBPACK FOOTER //
// ./src/pages/newprogram/consts.ts